import {IconButton, Typography, Toolbar, AppBar, Modal, Grid} from '@mui/material';
import React, {useState, useEffect, useRef} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {fromLonLat, transform} from 'ol/proj';
import {Fill, Stroke, Style} from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Polygon from 'ol/geom/Polygon';
import TileLayer from 'ol/layer/Tile';
import {observer} from 'mobx-react';
import Point from 'ol/geom/Point';
import Icon from 'ol/style/Icon';
import Feature from 'ol/Feature';
import {Control} from 'ol/control';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import Map from 'ol/Map';
import 'ol/ol.css';

import {getAutostationWeather, getMareographWeather, getWavebuoyWeather, getSunStr} from './Weather.js'
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import birderIconSmall from './images/watcher_6x16.png';
import {getCityName, getCountryName} from './Trans.js';
import birdIconSmall from './images/bird_16x16.png';
import birderIcon from './images/watcher.png';
import birdIcon from './images/bird.png';
import {tt_grid} from './a_grid.js';
import {COMM_OK} from './WsR2.js';

function showWeather(w) {
	let aw, mw, ww, sun;
	if (!w) 
		return '-';

// 	console.log('showWeather', w);

	aw = document.getElementById('autoweather');
	if (aw)
		aw.innerHTML = '';
	
	mw = document.getElementById('mareoweather');
	if (mw)
		mw.innerHTML = '';

	ww = document.getElementById('waveweather');
	if (ww)
		ww.innerHTML = '';

	sun = document.getElementById('sun');
	if (sun)
		sun.innerHTML = '';

	w.get.forEach((station) => {
		if (station.type === 'autostation' && aw) {
			aw.innerHTML = getAutostationWeather(station);
		} else if (station.type === 'mareograph' && mw) {
			mw.innerHTML = getMareographWeather(station);
		} else if (station.type === 'wavebuoy' & ww) {
			ww.innerHTML = getWavebuoyWeather(station);
		}
	});

	if (sun)
		sun.innerHTML = getSunStr(w.sun);
}

const ObsWeatherControl = (function (Control) {
	function ObsWeatherControl(pos, date, time, weather) {
//		console.log('ObsWeatherControl constructor', pos, date, time);

		var w, element = document.createElement('div');

		w = document.createElement('p');
		w.id = 'autoweather';
		element.appendChild(w);

		w = document.createElement('p');
		w.id = 'mareoweather';
		element.appendChild(w);

		w = document.createElement('p');
		w.id = 'waveweather';
		element.appendChild(w);

		w = document.createElement('p');
		w.id = 'sun';
		element.appendChild(w);

		showWeather(weather);

		Control.call(this, {
			element: element,
		});
	}

	if (Control) 
		ObsWeatherControl.__proto__ = Control;

	ObsWeatherControl.prototype = Object.create( Control && Control.prototype );
	ObsWeatherControl.prototype.constructor = ObsWeatherControl;

	return ObsWeatherControl;
} (Control));

const ObsTglBtn = observer((props) => {
	const leftPos = window.innerWidth - 40;

// 	console.log('props.is_bird', props.is_bird);

	const bg1 = props.isBirdPos ? 'rgba(255, 255, 255, 0)' : 'rgba(128, 128, 128, 0.8)';
	const bg2 = props.isBirdPos ? 'rgba(128, 128, 128, 0.8)' : 'rgba(255, 255, 255, 0)';

	return (
		<div ref={props.ctrlRef}>
			<button 
			    className='ol-custom ol-control' 
			    style={{top: 8, left: leftPos, width: 32, height: 32, backgroundColor: bg1}}
			    onClick={() => props.setBirder(true)}>
				<img src={birderIconSmall} alt='W'/>
			</button>
			<button 
			    className='ol-custom ol-control' 
			    style={{top: 40, left: leftPos, width: 32, height: 32, backgroundColor: bg2}}
			    onClick={() => props.setBirder(false)}>
				<img src={birdIconSmall} alt='B'/>
			</button>
			<button 
			    className='ol-custom ol-control' 
			    style={{top: 80, left: leftPos, width: 32, height: 32, fontWeight: 'bold'}}
			    onClick={() => props.removeBird(false)}
			    disabled={!props.pos[2] && !props.pos[3]}>
				X
			</button>
		</div>
	);
});

function ObsMap(props) {
	const [featuresLayer, setFeaturesLayer] = useState();
	const gStorage = useGlobalStorage();
	const ctrlRef = useRef(null);
	const mapRef = useRef(null);

	const initFeatures = () => {
		let center, zoom;

		if (props.pos && props.pos[0] && props.pos[1]) {
			center = fromLonLat(props.pos);
			zoom = 15;
		} else {
			/* Zoomaa Suomen kokoiseksi Jos koordinaatteja ei ole */
			center = fromLonLat([27.138596, 65.441896]);
			zoom = 5;
		}

		const initialFeaturesLayer = new VectorLayer({source: new VectorSource()});
		const initialWeatherControl = new ObsWeatherControl(props.pos, props.date, props.time, props.weather);

		const initialMap = new Map({
			controls: [initialWeatherControl],
			target: 'mapContainer',

			layers: [
				new TileLayer({
					source: new OSM(),
				}),
				initialFeaturesLayer
			],
			view: new View({
					center: center,
					zoom: zoom,
				}),
			moveTolerance: 8
			});

		initialMap.on('click', props.mapClick);
		setFeaturesLayer(initialFeaturesLayer);

		gStorage.add.setMap(initialMap);
		
		return initialFeaturesLayer;
	}

	useEffect(() => {
		const _featuresLayer = featuresLayer ? featuresLayer : initFeatures();

		const features = [];

		const long_obs = props.pos[0];
		const lat_obs = props.pos[1];

		if (long_obs && lat_obs) {
			const obsFeat = new Feature({
				geometry: new Point(transform([long_obs, lat_obs], 'EPSG:4326', 'EPSG:3857'))
			});

			const obsStyle = new Style({
				image: new Icon(({
					anchor: [0.3, 1],
					src: birderIcon,
					size: [12, 32]
				}))
			});

			obsFeat.setStyle(obsStyle);
			features.push(obsFeat);
		}

		const long_tgt = props.pos[2];
		const lat_tgt = props.pos[3];

		if (long_tgt && lat_tgt) {
			const tgtFeat = new Feature({
				geometry: new Point(transform([long_tgt, lat_tgt], 'EPSG:4326', 'EPSG:3857'))
			});
			const tgtStyle = new Style({
				image: new Icon(({
					anchor: [0.5, 1],
					src: birdIcon,
		    			size: [32, 32]
				}))
			});
			tgtFeat.setStyle(tgtStyle);
			features.push(tgtFeat);

			props.loadAtlas(lat_tgt, long_tgt);
		}

		// set features to map
		_featuresLayer.setSource(
			new VectorSource({
				features: features // make sure features is an array
			})
		)

		showWeather(props.weather);
		// eslint-disable-next-line
	}, [props.pos, props.weather]);

	useEffect(() => {
		if (!featuresLayer || !props.cell)
			return;

		const s = featuresLayer.getSource();
		if (!s) {
			console.log('no source!');
			return;
		}

		const f = new Feature({
			geometry: new Polygon(tt_grid[props.cell.id]),
		});

		f.setStyle(
			new Style({
				stroke: new Stroke({
					color: 'grey',
					width: 2,
				}),
				fill: new Fill({
					color: 'rgba(128, 128, 128, 0.3)',
				}),
			})
		)

		s.addFeature(f);
		// eslint-disable-next-line
	}, [props.cell]);

	useEffect(() => {
//  		console.log('useEffect, currents', mapRef.current, ctrlRef.current, popRef.current);

		if (mapRef.current) {
			gStorage.add.map.setTarget(mapRef.current);

			if (ctrlRef.current) {
				while (gStorage.add.map.getControls().getLength() > 2) {
					gStorage.add.map.removeControl(gStorage.add.map.getControls().getArray()[2]);
				}

				gStorage.add.map.addControl(new Control({element: ctrlRef.current}));
			}

		}
		// eslint-disable-next-line
	}, [mapRef.current, ctrlRef.current]);

	return (
		<div ref={mapRef} id="mapContainer" style={{flexGrow: 1, height: window.innerHeight - 48}}>
			<ObsTglBtn 
				mapRef={mapRef} 
				ctrlRef={ctrlRef}
				pos={props.pos}
				isBirdPos={props.isBirdPos} 
				setBirder={props.setBirder} 
				removeBird={props.removeBird}
			/>
		</div>
	);
}

let globalObserverPos = true;

const MapDialog = observer((props) => {
	const [observerPos, setObserverPos] = useState(true);
	const [cell, setCell] = useState(null);
	const gStorage = useGlobalStorage();

	useEffect(() => {
		globalObserverPos = observerPos;
		// eslint-disable-next-line
	}, []);

	function mapClick(evt) {
		let lonlat = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');

		if (globalObserverPos) {
			props.setPos({lat: lonlat[1], lng: lonlat[0]});
		} else {
			if (props.setBirdPos)
				props.setBirdPos({lat: lonlat[1], lng: lonlat[0]});
		}
	}

	function setObsTgt(is_bird) {
// 		console.log('setObsTgt', is_bird, observerPos);
		if (is_bird !== observerPos) {
			setObserverPos(!observerPos);
			globalObserverPos = !observerPos;
		} else {
			setObserverPos(observerPos);
			globalObserverPos = observerPos;
		}
	}

	function removeBirdPos() {
		props.setBirdPos({lat: 0, lng: 0});
		setCell(null);
	}

	function mapGetCityName(city) {
		const usr = gStorage.conn.user;
		let a_str = '';

		if (city.country !== usr.def_country) {
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);
			a_str = getCountryName(country, usr) + ', ';
		}

		return a_str += getCityName(city, gStorage.conn.user);
	}

	function handleCancel() {
// 		console.log('handleCancel');
		props.onClose();
	}

	function mapRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('naviRxWs: error ', status);
			return -1;
		}

// 		console.log('mapRxWs:', msg.data);

		if (msg.cmd === 'geo') {
			if (msg.op === 'cell') {
				if (msg.result === 'OK') {
					if (msg.data.cell === 'not found') {
						console.log('mapRxWs: cell for coordinates not found!');
						setCell(null);
					} else {
// 						const c = gStorage.lists.citylist.list.find(c => c.id === msg.data.cell.city_id);
						msg.data.cell.city = gStorage.lists.citylist.list.find(c => c.id === msg.data.cell.city_id);
						setCell(msg.data.cell);
					}
				} else {
					alert('mapRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('mapRxWs: unknown operation:', msg.cmd, msg.op);
			}
		} else {
			console.error('mapRxWs: unknown cmd', msg.cmd, msg.op);
		}
	}

	function loadAtlas(lat, lon) {
// 		console.log('loadAtlas', lat, lon);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'geo',
			op: 'cell',
			data: {
				coord: {
					lat: Math.floor(lat * 1000000.0),
					long: Math.floor(lon * 1000000.0),
				},
				city_only_allowed: 0
			},
		};

		gStorage.conn.ws.send(msg, mapRxWs);
	}

	let loc = gStorage.add.city ? mapGetCityName(gStorage.add.city) : '';
	if (cell)
		loc += ' (' + cell.n + ':' + cell.e + ' ' + mapGetCityName(cell.city) + ', ' + cell.name + ')'; 

	return (
		<Modal open={props.mapOpen} onClose={props.onClose}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<AppBar position="sticky">
						<Toolbar variant="dense">
							<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{loc}</Typography>
							<IconButton edge="start" color="inherit" onClick={handleCancel} aria-label="close">
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<ObsMap
						pos={props.pos} 
						date={props.date} 
						time={props.time} 
						cell={cell}
						weather={gStorage.add.weather}
						isBirdPos={!observerPos}
						setBirder={setObsTgt}
						removeBird={removeBirdPos}
						loadAtlas={loadAtlas}
						mapClick={mapClick}/>
				</Grid>
			</Grid>
		</Modal>
	)
});

export default MapDialog;
